<template>
  <div class="col-12" style="margin-top:0.5em;">
    <div class="row">
      <div class="col-lg-6">
        <card class="report-image rounded">
          <dynamic-image-background v-if="report.training && report.training.image" :file-id="report.training.image" background-style="">
          </dynamic-image-background>
          <div class="col-12" style="padding:0px;position:absolute;top:1em;color: wheat;">
            <div class="col-6" style="padding:0px;display: inline-block;">
              <div class="col-12" style="padding:0px;text-align:center;font-size: 2.5em;
            font-weight: 600;">
                <span>{{ `DAY ${report.day}` }}</span>
              </div>

              <div class="col-12" style="padding:0px;text-align:center;font-size: 1em;
            font-weight: 600;">
                <span>{{ $t('message.COMPLETED') }}</span>
              </div>

            </div>
          </div>
          <div class="col-12" style="padding:0px;position:absolute;bottom:1em;color: wheat;">
            <div class="col-6" style="padding:0px;display: inline-block; border-right: 1px solid;">
              <div class="col-12" style="padding:0px;text-align:center;font-size: 2em;
            font-weight: 600;">
                <span>{{ report.exerciseTracker.length }}</span>
              </div>

              <div class="col-12" style="padding:0px;text-align:center">
                <span>{{ $t('message.Exercises') }}</span>
              </div>

            </div>
            <div class="col-6" style="padding:0px;display: inline-block;">
              <div class="col-12" style="padding:0px;text-align:center;font-size: 2em;
            font-weight: 600;">
                {{ getDuration(report) }}
              </div>

              <div class="col-12" style="padding:0px;text-align:center">
                <span>{{ $t('message.Duration') }}</span>
              </div>

            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-6">
        {{ $t('message.Exercises') }}
        <card class="rounded exercises">
          <div class="col-12">
            <div class="col-12" style="padding:0px" v-for="exercise in report.exerciseTracker" :key="exercise._id">
              <div class="col-6" style="padding:0px;display: inline-block;">
                <span>{{ exercise.exercise.name }}</span> <span v-if="exercise.exercise.durationType == 'reps'"> ({{ getNumberOfReps(exercise.exercise) }} reps)</span>
              </div>

              <div class="col-2" style="padding:0px;display: inline-block;">
                <span>-</span>
              </div>

              <div class="col-4" style="padding:0px;display: inline-block;">
                {{ getDurationForExercises(exercise) }}
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

  </div>
</template>

<script>
import DynamicImageBackground from "../components/DynamicImageBackground.vue";
export default {
  components: { DynamicImageBackground },
  data() {
    return {};
  },

  async mounted() {
    console.log(this.report);
  },

  computed: {
    report() {
      return this.$store.state.fitnessOrYogaReport;
    },
  },

  methods: {
    getDuration(dayReport) {
      let duration = null;
      for (let exercise of dayReport.exerciseTracker) {
        if (exercise.latestStatus == "COMPLETED") {
          let startTime = exercise.statusHistory[0].timestamp;
          let endTime =
            exercise.statusHistory[exercise.statusHistory.length - 1].timestamp;
          let seconds = Math.floor((endTime - startTime) / 1000);
          let minutes = Math.floor(seconds / 60);
          let hours = Math.floor(minutes / 60);

          if (!duration) {
            duration = {
              hours: 0,
              minutes: 0,
              seconds: 0,
            };
          }

          duration = {
            hours: duration.hours + hours,
            minutes: duration.minutes + minutes,
            seconds: duration.seconds + seconds,
          };
        }
      }

      if (duration) {
        let days = Math.floor(duration.hours / 24);
        duration.hours = duration.hours - days * 24;
        duration.minutes =
          duration.minutes - days * 24 * 60 - duration.hours * 60;
        duration.seconds =
          duration.seconds -
          days * 24 * 60 * 60 -
          duration.hours * 60 * 60 -
          duration.minutes * 60;

        duration = `${("0" + duration.hours).slice(-2)}:${(
          "0" + duration.minutes
        ).slice(-2)}:${("0" + duration.seconds).slice(-2)}`;
      }

      return duration;
    },

    getDurationForExercises(exercise) {
      let duration = null;
      if (exercise.latestStatus == "COMPLETED") {
        let startTime = exercise.statusHistory[0].timestamp;
        let endTime =
          exercise.statusHistory[exercise.statusHistory.length - 1].timestamp;
        let seconds = Math.floor((endTime - startTime) / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);

        if (!duration) {
          duration = {
            hours: 0,
            minutes: 0,
            seconds: 0,
          };
        }

        duration = {
          hours: duration.hours + hours,
          minutes: duration.minutes + minutes,
          seconds: duration.seconds + seconds,
        };
      }

      if (duration) {
        let days = Math.floor(duration.hours / 24);
        duration.hours = duration.hours - days * 24;
        duration.minutes =
          duration.minutes - days * 24 * 60 - duration.hours * 60;
        duration.seconds =
          duration.seconds -
          days * 24 * 60 * 60 -
          duration.hours * 60 * 60 -
          duration.minutes * 60;

        duration = `${("0" + duration.hours).slice(-2)}:${(
          "0" + duration.minutes
        ).slice(-2)}:${("0" + duration.seconds).slice(-2)}`;
      }

      return duration;
    },

    getNumberOfReps(_exercise) {
      let reps = 0;
      for (let day of this.report.training.days) {
        for (let exercise of day.exercises) {
          if (exercise.exercise == _exercise._id) {
            return exercise.duration;
          }
        }
      }
      return reps;
    },
  },
};
</script>

<style scoped>
/deep/ .report-image .card-body {
  padding: 0px;
  height: 20em;
  background: rgb(0 0 0 / 60%);
}

/deep/ .exercises .card-body {
  padding: 15px;
}
</style>
